// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/modules/Courier/pages/CourierModal/pages/Scanners/styles/ScannerComponent.module.css */

/* Общий контейнер для всего компонента сканера */

.ScannerV2_container__Ciwrt {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0px;
}
.ScannerV2_videoContainer__Oduz3 {
  position: relative;
  width: 100%;
  max-width: 300px;
  aspect-ratio: 1 / 1;
  background: #333;
  border-radius: 10px;
  overflow: hidden;

  /* вот эти строки нужно добавить: */
}

/* «Принудительно» вписать видео в контейнер */
.ScannerV2_videoContainer__Oduz3 > video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}
/* Скрытый элемент canvas для захвата изображений */
.ScannerV2_hiddenCanvas__3ocFP {
  display: none;
}

/* Кнопка захвата фото */
.ScannerV2_photoButton__aRw\\+L {
  position: absolute;
  bottom: 8px;
  left: 8px;
  background: transparent;
  border: none;
  font-size: 32px;
  cursor: pointer;
  z-index: 10;
}

.ScannerV2_settingsButton__1Naeh {
  position: absolute;
  top: 8px;
  left: 8px;
  background: transparent;
  border: none;
  font-size: 32px;
  cursor: pointer;
  z-index: 10;
}

/* Кнопка фонарика */
.ScannerV2_flashButton__fUilp {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: transparent;
  border: none;
  font-size: 32px;
  cursor: pointer;
  z-index: 10;
  color: yellow;

}

/* Оверлей области сканирования */
.ScannerV2_overlay__QLxGW {
  position: absolute;
  width: 60%;
  max-width: 150px;
  aspect-ratio: 1 / 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 3px dashed #007bff;
  border-radius: 10px;
  pointer-events: none;
  z-index: 1;
}

/* Фокус-оверлей */
.ScannerV2_focusOverlay__BNYjQ {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2px solid lime;
  box-sizing: border-box;
  pointer-events: none;
  z-index: 3;
}

/* Статусное сообщение о процессе сканирования */
.ScannerV2_statusMessage__IuOsF {
  margin-top: 12px;
  background-color: #007bff;
  color: #fff;
  font-size: 16px;
  padding: 8px 12px;
  border-radius: 5px;
  text-align: center;
}

/* Блок управления (кнопки) */
.ScannerV2_controls__4Efrk {
  margin-top: 8px;
  display: flex;
  gap: 16px;
}

/* Быстрый белый флеш, когда делают фото */
.ScannerV2_flashEffect__gXPG6 {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: white;
  opacity: 0.8;
  pointer-events: none;
  animation: ScannerV2_flashFade__0kMAz 0.15s ease-out;
}

@keyframes ScannerV2_flashFade__0kMAz {
  from { opacity: 0.8; }
  to   { opacity: 0; }
}

.ScannerV2_flashButton__fUilp, .ScannerV2_photoButton__aRw\\+L, .ScannerV2_settingsButton__1Naeh {
  color: #888;
  transition: color 0.2s ease;
}

.ScannerV2_flashOnActive__WaCZD {
  color: yellow;
}

.ScannerV2_photoFlashActive__n3vEM {
  color: #ff4081;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/pages/Scanners/styles/ScannerV2.module.css"],"names":[],"mappings":"AAAA,6FAA6F;;AAE7F,iDAAiD;;AAEjD;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;;EAEhB,mCAAmC;AACrC;;AAEA,8CAA8C;AAC9C;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA,mDAAmD;AACnD;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;;AAEf;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,oDAAmC;AACrC;;AAEA;EACE,OAAO,YAAY,EAAE;EACrB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* src/modules/Courier/pages/CourierModal/pages/Scanners/styles/ScannerComponent.module.css */\r\n\r\n/* Общий контейнер для всего компонента сканера */\r\n\r\n.container {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin-bottom: 0px;\r\n}\r\n.videoContainer {\r\n  position: relative;\r\n  width: 100%;\r\n  max-width: 300px;\r\n  aspect-ratio: 1 / 1;\r\n  background: #333;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n\r\n  /* вот эти строки нужно добавить: */\r\n}\r\n\r\n/* «Принудительно» вписать видео в контейнер */\r\n.videoContainer > video {\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  object-fit: cover !important;\r\n}\r\n/* Скрытый элемент canvas для захвата изображений */\r\n.hiddenCanvas {\r\n  display: none;\r\n}\r\n\r\n/* Кнопка захвата фото */\r\n.photoButton {\r\n  position: absolute;\r\n  bottom: 8px;\r\n  left: 8px;\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 32px;\r\n  cursor: pointer;\r\n  z-index: 10;\r\n}\r\n\r\n.settingsButton {\r\n  position: absolute;\r\n  top: 8px;\r\n  left: 8px;\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 32px;\r\n  cursor: pointer;\r\n  z-index: 10;\r\n}\r\n\r\n/* Кнопка фонарика */\r\n.flashButton {\r\n  position: absolute;\r\n  bottom: 8px;\r\n  right: 8px;\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 32px;\r\n  cursor: pointer;\r\n  z-index: 10;\r\n  color: yellow;\r\n\r\n}\r\n\r\n/* Оверлей области сканирования */\r\n.overlay {\r\n  position: absolute;\r\n  width: 60%;\r\n  max-width: 150px;\r\n  aspect-ratio: 1 / 1;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  border: 3px dashed #007bff;\r\n  border-radius: 10px;\r\n  pointer-events: none;\r\n  z-index: 1;\r\n}\r\n\r\n/* Фокус-оверлей */\r\n.focusOverlay {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 2px solid lime;\r\n  box-sizing: border-box;\r\n  pointer-events: none;\r\n  z-index: 3;\r\n}\r\n\r\n/* Статусное сообщение о процессе сканирования */\r\n.statusMessage {\r\n  margin-top: 12px;\r\n  background-color: #007bff;\r\n  color: #fff;\r\n  font-size: 16px;\r\n  padding: 8px 12px;\r\n  border-radius: 5px;\r\n  text-align: center;\r\n}\r\n\r\n/* Блок управления (кнопки) */\r\n.controls {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  gap: 16px;\r\n}\r\n\r\n/* Быстрый белый флеш, когда делают фото */\r\n.flashEffect {\r\n  position: absolute;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background: white;\r\n  opacity: 0.8;\r\n  pointer-events: none;\r\n  animation: flashFade 0.15s ease-out;\r\n}\r\n\r\n@keyframes flashFade {\r\n  from { opacity: 0.8; }\r\n  to   { opacity: 0; }\r\n}\r\n\r\n.flashButton, .photoButton, .settingsButton {\r\n  color: #888;\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.flashOnActive {\r\n  color: yellow;\r\n}\r\n\r\n.photoFlashActive {\r\n  color: #ff4081;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ScannerV2_container__Ciwrt`,
	"videoContainer": `ScannerV2_videoContainer__Oduz3`,
	"hiddenCanvas": `ScannerV2_hiddenCanvas__3ocFP`,
	"photoButton": `ScannerV2_photoButton__aRw+L`,
	"settingsButton": `ScannerV2_settingsButton__1Naeh`,
	"flashButton": `ScannerV2_flashButton__fUilp`,
	"overlay": `ScannerV2_overlay__QLxGW`,
	"focusOverlay": `ScannerV2_focusOverlay__BNYjQ`,
	"statusMessage": `ScannerV2_statusMessage__IuOsF`,
	"controls": `ScannerV2_controls__4Efrk`,
	"flashEffect": `ScannerV2_flashEffect__gXPG6`,
	"flashFade": `ScannerV2_flashFade__0kMAz`,
	"flashOnActive": `ScannerV2_flashOnActive__WaCZD`,
	"photoFlashActive": `ScannerV2_photoFlashActive__n3vEM`
};
export default ___CSS_LOADER_EXPORT___;
